<template>

    <div>

        <div class="row g-3" v-if="treatment.timezynk_no_show == 1">

            <div class="col-8 col-sm-4 col-lg-3">
                <span>{{  treatment.treatment_at }}</span>
            </div>
            <div class="col-12 col-sm-6 col-lg-5">
                <span><i>Bokat pass som ej använts.</i></span>
            </div>
            <div class="col-lg-4 d-none d-lg-flex" v-if="show_employee_workplace_column">
                <span v-if="treatment.employee_workplace">{{ treatment.employee_workplace.title }}</span>
            </div>

        </div>

        <div class="row g-3" v-else>
            <div class="col-8 col-sm-4 col-lg-3">
                <span>{{  treatment.treatment_at }}</span>
            </div>
            <div class="col-12 col-sm-6 col-lg-5" v-if="displayFrom == 'list'">
                <span>{{ treatment.employee.name }}</span>
            </div>
            <div class="col-lg-4 d-none d-lg-flex" v-if="show_employee_workplace_column">
                <span v-if="treatment.employee_workplace">{{ treatment.employee_workplace.title }}</span>
            </div>
            <div class="col-lg-4 d-none d-lg-flex" v-else>
            </div>
            <div class="col-sm-5 col-lg-4 d-none d-sm-flex">
                <span v-if="treatment.employee_part_payment_type === 'none'">
                    Nej
                </span>
                <span v-if="treatment.employee_part_payment_type === 'salary'">
                    {{ treatment.employee_part_payment_amount }} kr från lön
                </span>
                <span v-if="treatment.employee_part_payment_type === 'allowance'">
                    {{ treatment.employee_part_payment_amount }} kr från friskvård
                </span>
            </div>
            <div :class="{ 'col-12 col-sm-9 col-lg-7' : displayFrom == 'modal', 'col-sm-4 col-lg-4 d-none d-sm-flex' : displayFrom == 'list' }">
                <span v-if="treatment.treatment_workplace">{{ treatment.treatment_workplace.title }}</span>
                <span v-else>{{ treatment.clinic.card_name_clinic }}</span>
            </div>
            <div class="col-lg-4 d-none d-lg-flex">
                <span>{{ treatment.clinic.name_person }}</span>
            </div>

            <div class="col-4 col-sm-4 d-flex d-lg-none justify-content-end">
                <div class="fold-arrow" @click="foldRow = !foldRow" :class="{ 'folded' : foldRow == true }"><img class="arrow-icon" src="/images/company-portal/icon-arrow.svg"></div>
            </div>
            <div class="col-24 mt-4" :class="{ 'd-none' : foldRow != true }" style="border-top:1px solid #efefef;">
                <div class="row py-3">
                    <div class="col-24 col-sm-8 mb-sm-1"><b>Datum</b></div>
                    <div class="col-24 col-sm-16 mb-3 mb-sm-1">{{  treatment.treatment_at }}</div>
                    <div class="col-24 col-sm-8 mb-sm-1"><b>Anställd</b></div>
                    <div class="col-24 col-sm-16 mb-3 mb-sm-1">{{ treatment.employee.name }}</div>
                    <div class="col-24 col-sm-8 mb-sm-1" v-if="show_employee_workplace_column"><b>Arbetsplats</b></div>
                    <div class="col-24 col-sm-16 mb-3 mb-sm-1" v-if="show_employee_workplace_column">
                        <span v-if="treatment.employee_workplace">{{ treatment.employee_workplace.title }}</span>
                    </div>
                    <div class="col-24 col-sm-8 mb-sm-1"><b>Delbetalning</b></div>
                    <div class="col-24 col-sm-16 mb-3 mb-sm-1">
                        <span v-if="treatment.employee_part_payment_type === 'none'">
                            Nej
                        </span>
                        <span v-if="treatment.employee_part_payment_type === 'salary'">
                            {{ treatment.employee_part_payment_amount }} kr från lön
                        </span>
                        <span v-if="treatment.employee_part_payment_type === 'allowance'">
                            {{ treatment.employee_part_payment_amount }} kr från friskvård
                        </span>
                    </div>
                    <div class="col-24 col-sm-8 mb-sm-1"><b>Behandlingsplats</b></div>
                    <div class="col-24 col-sm-16 mb-3 mb-sm-1">
                        <span v-if="treatment.treatment_workplace">{{ treatment.treatment_workplace.title }}</span>
                        <span v-else>{{ treatment.clinic.card_name_clinic }}</span>
                    </div>
                    <div class="col-24 col-sm-8 mb-sm-1"><b>Massör</b></div>
                    <div class="col-24 col-sm-16 mb-sm-1">{{ treatment.clinic.name_person }}</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    props: {
        treatment: {
            required: true
        },
        displayFrom: {
            default: 'list' // modal || list
        },
        show_employee_workplace_column: {
            default: true
        }
    },

    data () {
        return {
            foldRow: false
        }
    }
}

</script>
